import * as actionTypes from '../../actionTypes';
import getScrollBarWidth from '../../../lib/getScrollBarWidth';

// initial state
export const initialState = {
  // default to Chrome user agent
  userAgent: 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_11_4) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/49.0.2623.112 Safari/537.36',

  // browser's scrollBarWidth stored on state
  scrollBarWidth: 15, // default to 15 as this is common

  pathHistory: []
};


export default function browserDataReducer(state = initialState, {type, ...action}) {
  switch (type) {
    case actionTypes.GET_SCROLLBAR_WIDTH:
      return {...state, scrollBarWidth: getScrollBarWidth()};

    case actionTypes.SET_USERAGENT:
      return {...state, userAgent: action.userAgent};

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./shared/redux/reducers/browserData/index.js